import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem } from '@archipro-design/aria';
import { labelClassName } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const ShippingPopup: StyleRule = ({ theme }) => ({
    '&.ui-dialog ': {
        justifySelf: 'flex-start',
        marginBottom: 'auto',
        backgroundColor: theme.siteVariables.colors.primitive.white,
        maxWidth: '100vw',
        maxHeight: '100vh',
        height: '100vh',
    },
    '& .ui-dialog__footer': {
        padding: pxArrayToRem([15, 18, 16, 18]),
        borderTop: `1px solid ${theme.siteVariables.colors.grey[100]}`,
    },
    '& .ui-dialog__content': {
        borderTop: '0 none',
    },
    [theme.screen.tablet]: {
        '&.ui-dialog ': {
            marginTop: pxToRem(145),
            height: 'auto',
            maxWidth: '90vw',
            maxHeight: '90vh',
        },
        '& .ui-dialog__footer': {
            padding: pxArrayToRem([0, 48, 48, 48]),
            borderTop: '0 none',
        },
    },
});

export const PopupContent: StyleRule = () => ({
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
});

export const PopupHeader: StyleRule = ({ theme }) => ({
    borderBottom: `1px solid ${theme.siteVariables.colors.charcoal[250]}`,
    padding: pxArrayToRem([12, 16, 11, 8]),
    [theme.screen.tablet]: {
        marginRight: theme.siteVariables.spaces['space-48'],
        borderBottomWeight: '2px',
        padding: pxArrayToRem([8, 8, 6, 8]),
    },
});

export const Title: StyleRule = ({ theme: { siteVariables } }) => ({
    color: siteVariables.colors.charcoal[250],
    ...siteVariables.textStyles.Text.Medium65,
});

export const BackButton: StyleRule = ({ theme }) => ({
    padding: 0,
    outline: 'none 0',
    maxHeight: pxToRem(40),
    [theme.screen.tablet]: {
        maxHeight: pxToRem(46),
    },
});
export const ConfirmButton: StyleRule = ({ theme }) => ({
    borderRadius: 0,
    ['& .' + labelClassName]: {
        ...theme.siteVariables.textStyles.Text.Roman55,
        textTransform: 'uppercase',
    },
});
